import { gql } from '@apollo/client';

import { PERMISSIONS_FRAGMENT } from '../fragments';

export const MY_PERMISSIONS = gql`
  query MyPermissions($userId: ID!, $organizationId: ID, $isGhostMode: Boolean) {
    myPermissions(userId: $userId, organizationId: $organizationId, isGhostMode: $isGhostMode) {
      roles
      adAccountPermissions {
        id
        permissions {
          ...permissionsFragment
        }
      }
      permissions {
        ...permissionsFragment
      }
    }
  }
  ${PERMISSIONS_FRAGMENT}
`;
